import { getRouteApi } from '@tanstack/react-router'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { InvoiceSubmittalDetails } from '~bank-invoices/types/Details'

import { columns } from './columns'
import { UploadButton } from './components/UploadButton'
import { useDeleteFile } from './hooks'

const routeApi = getRouteApi('/_app/invoices/$id')

export const TaxReportTable = () => {
  const invoice = routeApi.useLoaderData() as InvoiceSubmittalDetails
  const { InvoiceFileDeleteConfirmation, setFileToDelete } = useDeleteFile()

  return (
    <PageSection title="Files" face={PageSectionFace.SECONDARY} actions={<UploadButton />}>
      <Layer rounded shadowed>
        <InvoiceFileDeleteConfirmation />
        <Table
          dataQa={TableDataQa.BP_INVOICE_TAX_REPORT}
          columns={columns({ invoiceSubmittalId: invoice.id, setFileToDelete })}
          dataSource={invoice.files.map((el) => ({ item: el }))}
        />
      </Layer>
    </PageSection>
  )
}
